var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 4a1 1 0 011 1v3h25c.55 0 1 .447 1 1 0 .553-.45 1-1 1H10v25c0 .55-.447 1-1 1-.553 0-1-.45-1-1V10H5a1 1 0 110-2h3V5a1 1 0 011-1zm3 10c0-1.106.894-2 2-2h18c1.106 0 2 .894 2 2v12c0 1.106-.894 2-2 2H14c-1.106 0-2-.894-2-2V14zm2 12h18V14H14v12z"
  })));
}
export default SvgSign;